module.exports = __webpack_public_path__ + "static/media/rca_horizontal-negative.9fd19282.svg";